import React, {FunctionComponent} from "react";
import Input, {InputProps} from "./Input";

type InputEmailProps = Omit<InputProps<string>, "type" | "pattern">;

const InputEmail: FunctionComponent<InputEmailProps> = ({...inputAttr}) => {
    const getPattern = () => {
        const name = "[a-z0-9][a-z0-9\\-_\\+.]+";
        const domain = "[a-z0-9][a-z0-9\\-.]+";
        const tld = "\\.[a-z0-9]{2,}";
        return `${name}@(${domain}${tld})`;
    };

    return (
        <Input
            type="email"
            pattern={getPattern()}
            {...inputAttr}
        />
    );
};

export default InputEmail;
